import type { I18nLocale } from "@/modules/i18n/types"

export type Params = {
  careerCenterIdOld: number
  hasAdvices: boolean
  hasAppointments: boolean
  hasCareerExplorer: boolean
  hasCareerServiceSpotlight: boolean
  hasFreya: boolean
  hasHester: boolean
  hasInsights: boolean
  hasJobRoles: boolean
  hasMainCareerCenterRessources: boolean
  hasMarco: boolean
  hasRessources: boolean
  hasVasco: boolean
  locale: I18nLocale
  mainCareerCenterIdOld: number
  mainCareerCenterResourcesModuleLocalizedName?: string
  resourcesModuleLocalizedName?: string
}

export function getToolboxItem(params: Params): { href: string; name: string } | undefined {
  const {
    careerCenterIdOld,
    hasAdvices,
    hasAppointments,
    hasCareerExplorer,
    hasCareerServiceSpotlight,
    hasFreya,
    hasHester,
    hasInsights,
    hasJobRoles,
    hasMainCareerCenterRessources,
    hasMarco,
    hasRessources,
    hasVasco,
    locale,
    mainCareerCenterIdOld,
    mainCareerCenterResourcesModuleLocalizedName,
    resourcesModuleLocalizedName,
  } = params

  const primaryCareerCenterModules = [
    {
      enabled: hasAppointments,
      href: `/${locale}/v2/appointments`,
      moduleNameKey: "module_header_fo.nav_appointments",
    },
    {
      enabled: hasRessources,
      href: `/${locale}/handbook?school_id=${careerCenterIdOld}`,
      moduleNameKey: resourcesModuleLocalizedName || "module_header_fo.nav_resources",
    },
    {
      enabled: hasMainCareerCenterRessources,
      href: `/${locale}/handbook?school_id=${mainCareerCenterIdOld}`,
      moduleNameKey: mainCareerCenterResourcesModuleLocalizedName || "module_header_fo.nav_resources",
    },
    {
      enabled: hasInsights,
      href: `/${locale}/insights`,
      moduleNameKey: "module_header_fo.nav_community_insights",
    },
    {
      enabled: hasCareerExplorer,
      href: `/${locale}/career-explorer/dashboard`,
      moduleNameKey: "Career Explorer",
    },
  ]

  const hasSecondaryModulesSection =
    hasAdvices || hasJobRoles || hasCareerServiceSpotlight || hasFreya || hasMarco || hasVasco || hasHester

  const enabledPrimaryModules = primaryCareerCenterModules.filter(primaryModule => primaryModule.enabled)

  if (enabledPrimaryModules.length === 0 && !hasSecondaryModulesSection) return undefined

  return enabledPrimaryModules.length === 1 && !hasSecondaryModulesSection
    ? { href: enabledPrimaryModules[0].href, name: enabledPrimaryModules[0].moduleNameKey }
    : { href: `/${locale}/toolbox`, name: "Toolbox" }
}
